import { useMutation, UseMutationResult } from '@tanstack/react-query';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { DataKYCFileTct } from '@dealstack/shared/lib/generated';
import { addFilledKycForm } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';

export const useAddFilledKycForm = (): UseMutationResult<
	ApiV1.Response<DataKYCFileTct>,
	unknown,
	{ fileId: string; templateId: string; kycWorkflowId: string }
> => {
	return useMutation({
		mutationFn: ({
			fileId,
			templateId,
			kycWorkflowId,
		}: {
			fileId: string;
			templateId: string;
			kycWorkflowId: string;
		}) => addFilledKycForm({ fileId, templateId, kycWorkflowId }),
	});
};
